import React from "react";
import NavigationMenu from "./NavigationMenu";

export default props => <NavigationMenu {...props} />;
